import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import './index.less';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import Router from './routers';
import store from './store';
import reportWebVitals from 'reportWebVitals';
import { register } from 'serviceWorker';

dayjs.locale('zh-cn');

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider locale={zhCN}>
            <Router/>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')   
);
// const m: any = module;
// if (m.hot) {
//     m.hot.accept();
// }
reportWebVitals(console.log)
register()